<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<svg
   width="8.46667mm"
   height="8.4666672mm"
   viewBox="0 0 8.46667 8.4666672"
   version="1.1"
   id="svg1"
   inkscape:version="1.4.2 (ebf0e940, 2025-05-08)"
   sodipodi:docname="wait-circle.svg"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
  <sodipodi:namedview
     id="namedview1"
     pagecolor="#ffffff"
     bordercolor="#999999"
     borderopacity="1"
     inkscape:showpageshadow="2"
     inkscape:pageopacity="0"
     inkscape:pagecheckerboard="0"
     inkscape:deskcolor="#d1d1d1"
     inkscape:document-units="mm"
     inkscape:zoom="5.6568543"
     inkscape:cx="10.16466"
     inkscape:cy="19.887378"
     inkscape:window-width="1512"
     inkscape:window-height="920"
     inkscape:window-x="0"
     inkscape:window-y="34"
     inkscape:window-maximized="0"
     inkscape:current-layer="layer1" />
  <defs
     id="defs1" />
  <g
     inkscape:label="Layer 1"
     inkscape:groupmode="layer"
     id="layer1"
     transform="translate(-97.595149,-34.756863)">
    <ellipse
       style="fill:#000000;fill-opacity:0;stroke:#BCD9EF;stroke-width:2.11672;stroke-linecap:round;stroke-miterlimit:0;stroke-dasharray:none;stroke-opacity:1;paint-order:normal"
       id="path5"
       cx="101.82848"
       cy="38.990196"
       rx="3.1749749"
       ry="3.1749737" />
  </g>
</svg>
